<template>
  <Header :title="$t('sidebar.menu.configure')" />
  <div v-if="isPermissionDenied">
    <PermissionAlert :message="$t('common.no_permission')" />
  </div>
  <div v-else-if="readPermission" style="display: flex; width: 100%; gap: 8px" :class="{ onCollapse: !isMasterOpen }">
    <!-- Sidebar Container: Stack Master and Tenant Specific vertically -->
    <div class="jobHistorySidebarStack">
      <!-- MASTER Sidebar -->
      <div v-if="isMasterOpen" style="width: 100%">
        <div class="jobHistoryFilterContainer">
          <div class="jobHistoryHeaderFilter">
            <div class="headerBar">
              <div class="jobHeader" @click="toggleMasterDropdown">
                <img src="/arrowDown.png" alt="Arrow Icon" class="/arrowDownIcon" :class="{ rotated: !isMasterListOpen }" />
                <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.625C10.8397 8.625 9.72688 9.08594 8.90641 9.90641C8.08594 10.7269 7.625 11.8397 7.625 13C7.625 14.1603 8.08594 15.2731 8.90641 16.0936C9.72688 16.9141 10.8397 17.375 12 17.375C13.1603 17.375 14.2731 16.9141 15.0936 16.0936C15.9141 15.2731 16.375 14.1603 16.375 13C16.375 11.8397 15.9141 10.7269 15.0936 9.90641C14.2731 9.08594 13.1603 8.625 12 8.625ZM9.375 13C9.375 12.3038 9.65156 11.6361 10.1438 11.1438C10.6361 10.6516 11.3038 10.375 12 10.375C12.6962 10.375 13.3639 10.6516 13.8562 11.1438C14.3484 11.6361 14.625 12.3038 14.625 13C14.625 13.6962 14.3484 14.3639 13.8562 14.8562C13.3639 15.3484 12.6962 15.625 12 15.625C11.3038 15.625 10.6361 15.3484 10.1438 14.8562C9.65156 14.3639 9.375 13.6962 9.375 13Z" fill="var(--primary-color)" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9707 0.458252C11.4516 0.458252 11.0187 0.458252 10.6641 0.481585C10.3015 0.496188 9.94386 0.571102 9.6059 0.703252C9.21653 0.864356 8.8627 1.10059 8.56463 1.39845C8.26657 1.69632 8.0301 2.04999 7.86873 2.43925C7.69957 2.84759 7.65407 3.27925 7.6354 3.74825C7.63332 3.91973 7.58782 4.08789 7.50315 4.23702C7.41848 4.38616 7.29741 4.51141 7.15123 4.60109C7.00053 4.68313 6.83148 4.72562 6.6599 4.7246C6.48831 4.72358 6.31979 4.67908 6.17007 4.59525C5.75473 4.37592 5.35807 4.19975 4.9194 4.14142C4.50167 4.08647 4.07721 4.11434 3.67025 4.22344C3.26328 4.33254 2.8818 4.52072 2.54757 4.77725C2.26453 5.00414 2.02125 5.27659 1.82773 5.58342C1.6294 5.87975 1.4124 6.25425 1.1534 6.70342L1.12423 6.75475C0.864067 7.20392 0.648233 7.57842 0.4919 7.89809C0.328567 8.23175 0.200233 8.56075 0.153567 8.92475C0.042267 9.76824 0.27056 10.6214 0.788233 11.2966C1.05773 11.6478 1.4089 11.9033 1.80557 12.1529C1.95331 12.2405 2.0764 12.3642 2.16332 12.5123C2.25025 12.6604 2.29816 12.8282 2.30257 12.9999C2.29816 13.1716 2.25025 13.3394 2.16332 13.4875C2.0764 13.6357 1.95331 13.7593 1.80557 13.8469C1.4089 14.0966 1.0589 14.3521 0.788233 14.7033C0.531703 15.0375 0.343517 15.419 0.23442 15.8259C0.125324 16.2329 0.0974532 16.6574 0.1524 17.0751C0.200233 17.4391 0.3274 17.7681 0.490733 18.1018C0.648233 18.4214 0.864067 18.7959 1.12423 19.2451L1.1534 19.2964C1.4124 19.7456 1.6294 20.1201 1.82773 20.4164C2.03423 20.7233 2.2559 20.9998 2.54757 21.2214C2.88171 21.4782 3.26316 21.6666 3.67012 21.7758C4.07708 21.8851 4.50159 21.9132 4.9194 21.8584C5.35807 21.8001 5.75473 21.6251 6.17007 21.4046C6.31964 21.321 6.48796 21.2766 6.65932 21.2756C6.83068 21.2745 6.99951 21.3169 7.15007 21.3988C7.29743 21.4873 7.41957 21.6123 7.50476 21.7616C7.58995 21.9109 7.63534 22.0797 7.63657 22.2516C7.65407 22.7206 7.69957 23.1523 7.8699 23.5606C8.031 23.95 8.26724 24.3038 8.5651 24.6019C8.86297 24.8999 9.21663 25.1364 9.6059 25.2978C9.94423 25.4378 10.2942 25.4926 10.6641 25.5171C11.0187 25.5416 11.4516 25.5416 11.9707 25.5416H12.0291C12.5482 25.5416 12.9811 25.5416 13.3357 25.5183C13.7067 25.4926 14.0556 25.4378 14.3939 25.2966C14.7833 25.1355 15.1371 24.8993 15.4352 24.6014C15.7332 24.3035 15.9697 23.9499 16.1311 23.5606C16.3002 23.1523 16.3457 22.7206 16.3644 22.2516C16.3663 22.0799 16.4117 21.9115 16.4964 21.7622C16.581 21.6128 16.7022 21.4874 16.8486 21.3976C16.9994 21.3157 17.1685 21.2734 17.3401 21.2747C17.5116 21.2759 17.6801 21.3206 17.8297 21.4046C18.2451 21.6239 18.6417 21.8001 19.0804 21.8573C19.9239 21.9686 20.777 21.7403 21.4522 21.2226C21.7439 20.9986 21.9656 20.7233 22.1721 20.4164C22.3704 20.1201 22.5874 19.7456 22.8464 19.2964L22.8756 19.2451C23.1357 18.7959 23.3516 18.4214 23.5079 18.1018C23.6712 17.7681 23.7996 17.4379 23.8462 17.0751C23.9575 16.2316 23.7292 15.3784 23.2116 14.7033C22.9421 14.3521 22.5909 14.0966 22.1942 13.8469C22.0465 13.7593 21.9234 13.6357 21.8365 13.4875C21.7496 13.3394 21.7016 13.1716 21.6972 12.9999C21.6972 12.6756 21.8746 12.3536 22.1942 12.1529C22.5909 11.9033 22.9409 11.6478 23.2116 11.2966C23.4681 10.9624 23.6563 10.5809 23.7654 10.1739C23.8745 9.76695 23.9023 9.34248 23.8474 8.92475C23.7924 8.56612 23.6781 8.21914 23.5091 7.89809C23.3098 7.51049 23.0985 7.1292 22.8756 6.75475L22.8464 6.70342C22.6333 6.32318 22.4084 5.94966 22.1721 5.58342C21.9784 5.27701 21.7352 5.00496 21.4522 4.77842C21.1181 4.52168 20.7366 4.33329 20.3297 4.22399C19.9227 4.11469 19.4982 4.08664 19.0804 4.14142C18.6417 4.19975 18.2451 4.37475 17.8297 4.59525C17.6802 4.67887 17.5118 4.72326 17.3405 4.72428C17.1691 4.7253 17.0003 4.68292 16.8497 4.60109C16.7031 4.51169 16.5816 4.38656 16.4965 4.23741C16.4114 4.08825 16.3656 3.91995 16.3632 3.74825C16.3457 3.27925 16.3002 2.84759 16.1299 2.43925C15.9688 2.04988 15.7326 1.69605 15.4347 1.39799C15.1368 1.09992 14.7832 0.863451 14.3939 0.702085C14.0556 0.562085 13.7056 0.507252 13.3357 0.482752C12.9811 0.458252 12.5482 0.458252 12.0291 0.458252H11.9707ZM10.2756 2.31909C10.3654 2.28175 10.5019 2.24792 10.7831 2.22809C11.0712 2.20825 11.4446 2.20825 11.9999 2.20825C12.5552 2.20825 12.9286 2.20825 13.2167 2.22809C13.4979 2.24792 13.6344 2.28175 13.7242 2.31909C14.0824 2.46725 14.3659 2.75075 14.5141 3.10892C14.5607 3.22092 14.5992 3.39709 14.6144 3.81359C14.6494 4.73759 15.1266 5.62775 15.9736 6.11659C16.8206 6.60542 17.8297 6.57392 18.6476 6.14225C19.0162 5.94742 19.1877 5.89259 19.3091 5.87742C19.6924 5.82677 20.0801 5.93042 20.3871 6.16559C20.4641 6.22509 20.5621 6.32659 20.7196 6.55992C20.8817 6.80025 21.0684 7.12342 21.3461 7.60409C21.6237 8.08475 21.8092 8.40909 21.9364 8.66809C22.0612 8.92125 22.0997 9.05659 22.1114 9.15342C22.1621 9.53675 22.0584 9.9245 21.8232 10.2314C21.7486 10.3283 21.6156 10.4496 21.2632 10.6713C20.4792 11.1636 19.9472 12.0223 19.9472 12.9999C19.9472 13.9776 20.4792 14.8363 21.2632 15.3286C21.6156 15.5503 21.7486 15.6716 21.8232 15.7684C22.0589 16.0753 22.1616 16.4626 22.1114 16.8464C22.0997 16.9433 22.0601 17.0798 21.9364 17.3318C21.8092 17.5919 21.6237 17.9151 21.3461 18.3958C21.0684 18.8764 20.8806 19.1996 20.7196 19.4399C20.5621 19.6733 20.4641 19.7748 20.3871 19.8343C20.0801 20.0694 19.6924 20.1731 19.3091 20.1224C19.1877 20.1073 19.0174 20.0524 18.6476 19.8576C17.8309 19.4259 16.8206 19.3933 15.9736 19.8821C15.1266 20.3709 14.6494 21.2623 14.6144 22.1863C14.5992 22.6028 14.5607 22.7789 14.5141 22.8909C14.4408 23.068 14.3333 23.2289 14.1978 23.3645C14.0622 23.5 13.9013 23.6075 13.7242 23.6808C13.6344 23.7181 13.4979 23.7519 13.2167 23.7718C12.9286 23.7916 12.5552 23.7916 11.9999 23.7916C11.4446 23.7916 11.0712 23.7916 10.7831 23.7718C10.5019 23.7519 10.3654 23.7181 10.2756 23.6808C10.0985 23.6075 9.93756 23.5 9.80203 23.3645C9.66651 23.2289 9.55902 23.068 9.48573 22.8909C9.43907 22.7789 9.40057 22.6028 9.3854 22.1863C9.3504 21.2623 8.87323 20.3721 8.02623 19.8833C7.17923 19.3944 6.17007 19.4259 5.35223 19.8576C4.98357 20.0524 4.81207 20.1073 4.69073 20.1224C4.30741 20.1731 3.91966 20.0694 3.61273 19.8343C3.53573 19.7748 3.43773 19.6733 3.28023 19.4399C3.06076 19.0984 2.85183 18.7501 2.65373 18.3958C2.37607 17.9151 2.19057 17.5908 2.0634 17.3318C1.93857 17.0786 1.90007 16.9433 1.8884 16.8464C1.83775 16.4631 1.9414 16.0753 2.17657 15.7684C2.25123 15.6716 2.38423 15.5503 2.73657 15.3286C3.52057 14.8363 4.05257 13.9776 4.05257 12.9999C4.05257 12.0223 3.52057 11.1636 2.73657 10.6713C2.38423 10.4496 2.25123 10.3283 2.17657 10.2314C1.9414 9.9245 1.83775 9.53675 1.8884 9.15342C1.90007 9.05659 1.93973 8.92009 2.0634 8.66809C2.19057 8.40792 2.37607 8.08475 2.65373 7.60409C2.9314 7.12342 3.11923 6.80025 3.28023 6.55992C3.43773 6.32659 3.53573 6.22509 3.61273 6.16559C3.91966 5.93042 4.30741 5.82677 4.69073 5.87742C4.81207 5.89259 4.9824 5.94742 5.35223 6.14225C6.1689 6.57392 7.17923 6.60659 8.02623 6.11659C8.87323 5.62775 9.3504 4.73759 9.3854 3.81359C9.40057 3.39709 9.43907 3.22092 9.48573 3.10892C9.6339 2.75075 9.9174 2.46725 10.2756 2.31909Z" fill="var(--primary-color)" />
                </svg>
                <span class="jobsTitle">{{ $t('sidebar.menu.configure') }}</span>
              </div>

              <div @click="toggleMasterSidebar" style="cursor: pointer">
                <img :class="{ rotated: !isMasterOpen }" src="/hideSidebar.png" alt="Toggle Sidebar" />
              </div>
            </div>

            <div v-if="loading" style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; margin-top: 20px">
              <div class="spinner-border text-primary spinner-grow-xl" role="status"></div>
            </div>
            <div class="configureList" v-else-if="isMasterListOpen">
              <div v-for="({ name, translationKey }, idx) in configureList" :key="idx" class="jobItem" :class="{ jobItemActive: isRouteActive(name) }" @click="navigate(name)">
                <div v-if="isRouteActive(name)" class="vrCustom" />
                <span class="jobItemTitle">{{ $t(translationKey) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Master Collapsed -->
      <div v-if="!isMasterOpen" style="display: flex; gap: 32px; flex-direction: column; align-items: center; background-color: #ffffff; padding: 8px 0 8px 0; width: 100px; height: 85vh; width: 60px">
        <div @click="toggleMasterSidebar" style="display: flex; justify-content: center; align-items: center">
          <img :class="{ rotated: !isMasterOpen }" src="/hideSidebar.png" alt="Toggle Sidebar" />
        </div>
        <div style="background-color: #e9f1f6; display: flex; justify-content: center; padding: 4px; align-items: center">
          <svg width="24" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.625C10.8397 8.625 9.72688 9.08594 8.90641 9.90641C8.08594 10.7269 7.625 11.8397 7.625 13C7.625 14.1603 8.08594 15.2731 8.90641 16.0936C9.72688 16.9141 10.8397 17.375 12 17.375C13.1603 17.375 14.2731 16.9141 15.0936 16.0936C15.9141 15.2731 16.375 14.1603 16.375 13C16.375 11.8397 15.9141 10.7269 15.0936 9.90641C14.2731 9.08594 13.1603 8.625 12 8.625ZM9.375 13C9.375 12.3038 9.65156 11.6361 10.1438 11.1438C10.6361 10.6516 11.3038 10.375 12 10.375C12.6962 10.375 13.3639 10.6516 13.8562 11.1438C14.3484 11.6361 14.625 12.3038 14.625 13C14.625 13.6962 14.3484 14.3639 13.8562 14.8562C13.3639 15.3484 12.6962 15.625 12 15.625C11.3038 15.625 10.6361 15.3484 10.1438 14.8562C9.65156 14.3639 9.375 13.6962 9.375 13Z" fill="var(--primary-color)" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9707 0.458252C11.4516 0.458252 11.0187 0.458252 10.6641 0.481585C10.3015 0.496188 9.94386 0.571102 9.6059 0.703252C9.21653 0.864356 8.8627 1.10059 8.56463 1.39845C8.26657 1.69632 8.0301 2.04999 7.86873 2.43925C7.69957 2.84759 7.65407 3.27925 7.6354 3.74825C7.63332 3.91973 7.58782 4.08789 7.50315 4.23702C7.41848 4.38616 7.29741 4.51141 7.15123 4.60109C7.00053 4.68313 6.83148 4.72562 6.6599 4.7246C6.48831 4.72358 6.31979 4.67908 6.17007 4.59525C5.75473 4.37592 5.35807 4.19975 4.9194 4.14142C4.50167 4.08647 4.07721 4.11434 3.67025 4.22344C3.26328 4.33254 2.8818 4.52072 2.54757 4.77725C2.26453 5.00414 2.02125 5.27659 1.82773 5.58342C1.6294 5.87975 1.4124 6.25425 1.1534 6.70342L1.12423 6.75475C0.864067 7.20392 0.648233 7.57842 0.4919 7.89809C0.328567 8.23175 0.200233 8.56075 0.153567 8.92475C0.042267 9.76824 0.27056 10.6214 0.788233 11.2966C1.05773 11.6478 1.4089 11.9033 1.80557 12.1529C1.95331 12.2405 2.0764 12.3642 2.16332 12.5123C2.25025 12.6604 2.29816 12.8282 2.30257 12.9999C2.29816 13.1716 2.25025 13.3394 2.16332 13.4875C2.0764 13.6357 1.95331 13.7593 1.80557 13.8469C1.4089 14.0966 1.0589 14.3521 0.788233 14.7033C0.531703 15.0375 0.343517 15.419 0.23442 15.8259C0.125324 16.2329 0.0974532 16.6574 0.1524 17.0751C0.200233 17.4391 0.3274 17.7681 0.490733 18.1018C0.648233 18.4214 0.864067 18.7959 1.12423 19.2451L1.1534 19.2964C1.4124 19.7456 1.6294 20.1201 1.82773 20.4164C2.03423 20.7233 2.2559 20.9998 2.54757 21.2214C2.88171 21.4782 3.26316 21.6666 3.67012 21.7758C4.07708 21.8851 4.50159 21.9132 4.9194 21.8584C5.35807 21.8001 5.75473 21.6251 6.17007 21.4046C6.31964 21.321 6.48796 21.2766 6.65932 21.2756C6.83068 21.2745 6.99951 21.3169 7.15007 21.3988C7.29743 21.4873 7.41957 21.6123 7.50476 21.7616C7.58995 21.9109 7.63534 22.0797 7.63657 22.2516C7.65407 22.7206 7.69957 23.1523 7.8699 23.5606C8.031 23.95 8.26724 24.3038 8.5651 24.6019C8.86297 24.8999 9.21663 25.1364 9.6059 25.2978C9.94423 25.4378 10.2942 25.4926 10.6641 25.5171C11.0187 25.5416 11.4516 25.5416 11.9707 25.5416H12.0291C12.5482 25.5416 12.9811 25.5416 13.3357 25.5183C13.7067 25.4926 14.0556 25.4378 14.3939 25.2966C14.7833 25.1355 15.1371 24.8993 15.4352 24.6014C15.7332 24.3035 15.9697 23.9499 16.1311 23.5606C16.3002 23.1523 16.3457 22.7206 16.3644 22.2516C16.3663 22.0799 16.4117 21.9115 16.4964 21.7622C16.581 21.6128 16.7022 21.4874 16.8486 21.3976C16.9994 21.3157 17.1685 21.2734 17.3401 21.2747C17.5116 21.2759 17.6801 21.3206 17.8297 21.4046C18.2451 21.6239 18.6417 21.8001 19.0804 21.8573C19.9239 21.9686 20.777 21.7403 21.4522 21.2226C21.7439 20.9986 21.9656 20.7233 22.1721 20.4164C22.3704 20.1201 22.5874 19.7456 22.8464 19.2964L22.8756 19.2451C23.1357 18.7959 23.3516 18.4214 23.5079 18.1018C23.6712 17.7681 23.7996 17.4379 23.8462 17.0751C23.9575 16.2316 23.7292 15.3784 23.2116 14.7033C22.9421 14.3521 22.5909 14.0966 22.1942 13.8469C22.0465 13.7593 21.9234 13.6357 21.8365 13.4875C21.7496 13.3394 21.7016 13.1716 21.6972 12.9999C21.6972 12.6756 21.8746 12.3536 22.1942 12.1529C22.5909 11.9033 22.9409 11.6478 23.2116 11.2966C23.4681 10.9624 23.6563 10.5809 23.7654 10.1739C23.8745 9.76695 23.9023 9.34248 23.8474 8.92475C23.7924 8.56612 23.6781 8.21914 23.5091 7.89809C23.3098 7.51049 23.0985 7.1292 22.8756 6.75475L22.8464 6.70342C22.6333 6.32318 22.4084 5.94966 22.1721 5.58342C21.9784 5.27701 21.7352 5.00496 21.4522 4.77842C21.1181 4.52168 20.7366 4.33329 20.3297 4.22399C19.9227 4.11469 19.4982 4.08664 19.0804 4.14142C18.6417 4.19975 18.2451 4.37475 17.8297 4.59525C17.6802 4.67887 17.5118 4.72326 17.3405 4.72428C17.1691 4.7253 17.0003 4.68292 16.8497 4.60109C16.7031 4.51169 16.5816 4.38656 16.4965 4.23741C16.4114 4.08825 16.3656 3.91995 16.3632 3.74825C16.3457 3.27925 16.3002 2.84759 16.1299 2.43925C15.9688 2.04988 15.7326 1.69605 15.4347 1.39799C15.1368 1.09992 14.7832 0.863451 14.3939 0.702085C14.0556 0.562085 13.7056 0.507252 13.3357 0.482752C12.9811 0.458252 12.5482 0.458252 12.0291 0.458252H11.9707ZM10.2756 2.31909C10.3654 2.28175 10.5019 2.24792 10.7831 2.22809C11.0712 2.20825 11.4446 2.20825 11.9999 2.20825C12.5552 2.20825 12.9286 2.20825 13.2167 2.22809C13.4979 2.24792 13.6344 2.28175 13.7242 2.31909C14.0824 2.46725 14.3659 2.75075 14.5141 3.10892C14.5607 3.22092 14.5992 3.39709 14.6144 3.81359C14.6494 4.73759 15.1266 5.62775 15.9736 6.11659C16.8206 6.60542 17.8297 6.57392 18.6476 6.14225C19.0162 5.94742 19.1877 5.89259 19.3091 5.87742C19.6924 5.82677 20.0801 5.93042 20.3871 6.16559C20.4641 6.22509 20.5621 6.32659 20.7196 6.55992C20.8817 6.80025 21.0684 7.12342 21.3461 7.60409C21.6237 8.08475 21.8092 8.40909 21.9364 8.66809C22.0612 8.92125 22.0997 9.05659 22.1114 9.15342C22.1621 9.53675 22.0584 9.9245 21.8232 10.2314C21.7486 10.3283 21.6156 10.4496 21.2632 10.6713C20.4792 11.1636 19.9472 12.0223 19.9472 12.9999C19.9472 13.9776 20.4792 14.8363 21.2632 15.3286C21.6156 15.5503 21.7486 15.6716 21.8232 15.7684C22.0589 16.0753 22.1616 16.4626 22.1114 16.8464C22.0997 16.9433 22.0601 17.0798 21.9364 17.3318C21.8092 17.5919 21.6237 17.9151 21.3461 18.3958C21.0684 18.8764 20.8806 19.1996 20.7196 19.4399C20.5621 19.6733 20.4641 19.7748 20.3871 19.8343C20.0801 20.0694 19.6924 20.1731 19.3091 20.1224C19.1877 20.1073 19.0174 20.0524 18.6476 19.8576C17.8309 19.4259 16.8206 19.3933 15.9736 19.8821C15.1266 20.3709 14.6494 21.2623 14.6144 22.1863C14.5992 22.6028 14.5607 22.7789 14.5141 22.8909C14.4408 23.068 14.3333 23.2289 14.1978 23.3645C14.0622 23.5 13.9013 23.6075 13.7242 23.6808C13.6344 23.7181 13.4979 23.7519 13.2167 23.7718C12.9286 23.7916 12.5552 23.7916 11.9999 23.7916C11.4446 23.7916 11.0712 23.7916 10.7831 23.7718C10.5019 23.7519 10.3654 23.7181 10.2756 23.6808C10.0985 23.6075 9.93756 23.5 9.80203 23.3645C9.66651 23.2289 9.55902 23.068 9.48573 22.8909C9.43907 22.7789 9.40057 22.6028 9.3854 22.1863C9.3504 21.2623 8.87323 20.3721 8.02623 19.8833C7.17923 19.3944 6.17007 19.4259 5.35223 19.8576C4.98357 20.0524 4.81207 20.1073 4.69073 20.1224C4.30741 20.1731 3.91966 20.0694 3.61273 19.8343C3.53573 19.7748 3.43773 19.6733 3.28023 19.4399C3.06076 19.0984 2.85183 18.7501 2.65373 18.3958C2.37607 17.9151 2.19057 17.5908 2.0634 17.3318C1.93857 17.0786 1.90007 16.9433 1.8884 16.8464C1.83775 16.4631 1.9414 16.0753 2.17657 15.7684C2.25123 15.6716 2.38423 15.5503 2.73657 15.3286C3.52057 14.8363 4.05257 13.9776 4.05257 12.9999C4.05257 12.0223 3.52057 11.1636 2.73657 10.6713C2.38423 10.4496 2.25123 10.3283 2.17657 10.2314C1.9414 9.9245 1.83775 9.53675 1.8884 9.15342C1.90007 9.05659 1.93973 8.92009 2.0634 8.66809C2.19057 8.40792 2.37607 8.08475 2.65373 7.60409C2.9314 7.12342 3.11923 6.80025 3.28023 6.55992C3.43773 6.32659 3.53573 6.22509 3.61273 6.16559C3.91966 5.93042 4.30741 5.82677 4.69073 5.87742C4.81207 5.89259 4.9824 5.94742 5.35223 6.14225C6.1689 6.57392 7.17923 6.60659 8.02623 6.11659C8.87323 5.62775 9.3504 4.73759 9.3854 3.81359C9.40057 3.39709 9.43907 3.22092 9.48573 3.10892C9.6339 2.75075 9.9174 2.46725 10.2756 2.31909Z" fill="var(--primary-color)" />
          </svg>
        </div>
        <div v-for="({ name, icon }, idx) in configureList" :key="idx" style="display: flex; justify-content: center; align-items: center" :class="[{ activeItem: isRouteActive(name) }]" @click="navigate(name)">
          <img :src="icon" :alt="`${name} Icon`" class="configureItemIcon" />
        </div>
      </div>
    </div>
    <div style="width: 100%">
      <router-view v-if="readPermission" />
      <div v-else class="no-write-permission">
        <PermissionAlert :message="$t('configure.permissions.no_modify_permission')" />
      </div>
    </div>
  </div>
  <div v-else>
    <PermissionAlert :message="$t('configure.permissions.no_view_permission')" />
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import PermissionAlert from '../../components/PermissionAlert.vue'
import tenantSelectionStore from '@/stores/tenantSelectionStore'

export default {
  components: {
    Header,
    PermissionAlert,
  },
  data() {
    return {
      readPermission: false,
      writePermission: false,
      isOpen: true,
      isMasterListOpen: true,
      isTenantListOpen: true,
      isMasterOpen: true,
      isTenantOpen: true,
      userRole: '',
      roleId: 0,
      isPermissionDenied: false,
      selectedItem: 'Primary Classification',
      loading: false,
      selectedTenantUsesBedrock: false,
      selectedTenantUsesTextract: false,
      tenantStoreUnsubscribe: null,
      isLoadingTenantConfig: false, // Add loading state for Tenant Admin
      routeMap: {
        'Primary Classification': ['ConfigureCategories', 'CategoryDetails'],
        'Sub-Categories': ['ConfigureDepartments'],
        'Document Types': ['ConfigureDocumentTypes'],
        // 'IDP Document Classes': ['ConfigureIDPDocumentClasses'],
        Models: ['ConfigureModels'],
        'Extraction Fields': ['ConfigureExtractionFields'],
      },
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    configureList() {
      // For Tenant Admin: show empty array while loading tenant config to prevent flash
      if (this.userRole === 'Tenant Admin' && this.isLoadingTenantConfig) {
        return []
      }
      console.log('this.selectedTenantUsesTextract===>', this.selectedTenantUsesTextract)

      // If using Bedrock or Textract, only show Document Types (applies to all users including Super Admin)
      if (this.selectedTenantUsesBedrock || this.selectedTenantUsesTextract) {
        return [{ name: 'Document Types', translationKey: 'configure.navigation.document_types', icon: '/document.png' }]
      }

      // Otherwise show all menu items
      return [{ name: 'Primary Classification', translationKey: 'configure.navigation.primary_classification', icon: '/classification.png' }, { name: 'Sub-Categories', translationKey: 'configure.navigation.sub_categories', icon: '/subcategories.png' }, { name: 'Document Types', translationKey: 'configure.navigation.document_types', icon: '/document.png' }, ...(this.userRole !== 'Tenant Admin' ? [{ name: 'Models', translationKey: 'configure.navigation.models', icon: '/model.png' }] : []), { name: 'Extraction Fields', translationKey: 'configure.navigation.extraction_fields', icon: '/fields.png' }]
    },
  },
  mounted() {
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 2000)
    const userRolesString = localStorage.getItem('UserRoles')
    try {
      const userRoles = JSON.parse(userRolesString)
      this.userRole = userRoles[0]?.role?.roleName || ''
      this.roleId = userRoles[0]?.roleId || 0

      // Check if user is Tenant User (roleId === 3)
      if (this.roleId === 3) {
        this.isPermissionDenied = true
      }
    } catch (e) {
      this.userRole = ''
      this.roleId = 0
    }

    // Subscribe to store for immediate tenant changes
    this.tenantStoreUnsubscribe = tenantSelectionStore.subscribe((state) => {
      this.selectedTenantUsesBedrock = state.selectedTenantUsesBedrock
      this.selectedTenantUsesTextract = state.selectedTenantUsesTextract
    })

    // For Tenant Admin users, wait for TenantDetails if not available
    if (this.userRole === 'Tenant Admin') {
      const tenantDetails = localStorage.getItem('TenantDetails')
      if (!tenantDetails) {
        this.isLoadingTenantConfig = true // Hide navigation while loading
        this.waitForTenantDetails()
      } else {
        this.initializeTenantAdmin()
      }
    } else {
      // Use tenant selection store as source of truth for non-Tenant Admin users
      const storeState = tenantSelectionStore.getCurrentState()
      this.selectedTenantUsesBedrock = storeState.selectedTenantUsesBedrock
      this.selectedTenantUsesTextract = storeState.selectedTenantUsesTextract
      console.log('Configure: Initial bedrock status from store:', this.selectedTenantUsesBedrock)
      console.log('Configure: Initial textract status from store:', this.selectedTenantUsesTextract)

      tenantSelectionStore
        .initializeRegularUserAiMethod()
        .then(() => {
          const newState = tenantSelectionStore.getCurrentState()
          if (this.selectedTenantUsesBedrock !== newState.selectedTenantUsesBedrock || this.selectedTenantUsesTextract !== newState.selectedTenantUsesTextract) {
            this.selectedTenantUsesBedrock = newState.selectedTenantUsesBedrock
            this.selectedTenantUsesTextract = newState.selectedTenantUsesTextract
            this.$forceUpdate()
          }
        })
        .catch((error) => {
          console.error('Configure: Failed to initialize AI method:', error)
        })
    }

    // Add a delayed check in case there are timing issues
    setTimeout(() => {
      const delayedState = tenantSelectionStore.getCurrentState()
      if (this.selectedTenantUsesBedrock !== delayedState.selectedTenantUsesBedrock) {
        this.selectedTenantUsesBedrock = delayedState.selectedTenantUsesBedrock
        this.selectedTenantUsesTextract = delayedState.selectedTenantUsesTextract
        this.$forceUpdate()
      }
    }, 1000)

    this.checkPermissions()

    // If using Bedrock and current route is not Document Types, redirect to Document Types (applies to all users)
    if (this.selectedTenantUsesBedrock && this.currentRouteName !== 'ConfigureDocumentTypes') {
      this.selectedItem = 'Document Types'
      this.$router.push({ name: 'ConfigureDocumentTypes' })
    } else {
      // Set selectedItem based on current route name
      const match = Object.entries(this.routeMap).find(([routeNames]) => routeNames.includes(this.currentRouteName))
      if (match) {
        this.selectedItem = match[0]
      }
    }
    document.title = this.selectedItem

    // Listen for custom tenant change events
    window.addEventListener('tenantBedrockStatusChanged', this.handleTenantBedrockChange)
    window.addEventListener('tenantTextractStatusChanged', this.handleTenantTextractChange)
  },
  beforeUnmount() {
    // Remove event listeners
    window.removeEventListener('tenantBedrockStatusChanged', this.handleTenantBedrockChange)
    window.removeEventListener('tenantTextractStatusChanged', this.handleTenantTextractChange)
    // Unsubscribe from tenant selection store
    if (this.tenantStoreUnsubscribe) {
      this.tenantStoreUnsubscribe()
    }
  },
  watch: {
    $route(newRoute) {
      // Update selected tab if route changes
      const match = Object.entries(this.routeMap).find(([routeNames]) => routeNames.includes(newRoute.name))
      if (match && this.selectedItem !== match[0]) {
        this.selectedItem = match[0]
      }

      // Update tenant Bedrock and Textract status if route changes (for all users)
      // This ensures the navigation stays in sync after route changes
      this.updateTenantBedrockStatus()
      this.updateTenantTextractStatus()
    },
    selectedTenantUsesBedrock(newValue, oldValue) {
      console.log('Configure: selectedTenantUsesBedrock watcher triggered')
      console.log('Old value:', oldValue, 'New value:', newValue)

      // Force update the computed property (configureList)
      this.$forceUpdate()

      // Redirect to Document Types immediately when tenant uses Bedrock
      if (newValue && this.currentRouteName !== 'ConfigureDocumentTypes') {
        this.selectedItem = 'Document Types'
        this.$router.push({ name: 'ConfigureDocumentTypes' })
      }
    },
    selectedTenantUsesTextract(newValue, oldValue) {
      console.log('Configure: selectedTenantUsesTextract watcher triggered')
      console.log('Old value:', oldValue, 'New value:', newValue)

      // Force update the computed property (configureList)
      this.$forceUpdate()

      // Redirect to Document Types immediately when tenant uses Textract
      if (newValue && this.currentRouteName !== 'ConfigureDocumentTypes') {
        console.log('Configure: Textract tenant detected, redirecting to Document Types')
        this.selectedItem = 'Document Types'
        this.$router.push({ name: 'ConfigureDocumentTypes' })
      }
    },
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.readPermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_RD' && p.is_active)
      this.writePermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_WR' && p.is_active)
    },
    isRouteActive(item) {
      const validRoutes = this.routeMap[item] || []
      return validRoutes.includes(this.currentRouteName)
    },
    toggleMasterDropdown() {
      this.isMasterListOpen = !this.isMasterListOpen
    },
    toggleTenantDropdown() {
      this.isTenantListOpen = !this.isTenantListOpen
    },
    toggleMasterSidebar() {
      this.isMasterOpen = !this.isMasterOpen
    },
    toggleTenantSidebar() {
      this.isTenantOpen = !this.isTenantOpen
    },
    navigate(item) {
      const routeNames = this.routeMap[item]
      const name = Array.isArray(routeNames) ? routeNames[0] : routeNames
      if (name) {
        this.selectedItem = item
        this.$router.push({ name })
      }
    },
    updateTenantBedrockStatus() {
      // Always use tenant selection store as single source of truth
      const storeState = tenantSelectionStore.getCurrentState()
      if (this.selectedTenantUsesBedrock !== storeState.selectedTenantUsesBedrock) {
        this.selectedTenantUsesBedrock = storeState.selectedTenantUsesBedrock
        this.$forceUpdate() // Force Vue to re-render the navigation
      }
    },
    updateTenantTextractStatus() {
      // Always use tenant selection store as single source of truth
      const storeState = tenantSelectionStore.getCurrentState()
      if (this.selectedTenantUsesTextract !== storeState.selectedTenantUsesTextract) {
        this.selectedTenantUsesTextract = storeState.selectedTenantUsesTextract
        this.$forceUpdate() // Force Vue to re-render the navigation
      }
    },
    handleTenantBedrockChange() {
      // Listen for changes to tenant bedrock status (for all users)
      this.updateTenantBedrockStatus()

      // Force immediate redirect if tenant now uses Bedrock and we're not on Document Types
      if (this.selectedTenantUsesBedrock && this.currentRouteName !== 'ConfigureDocumentTypes') {
        this.selectedItem = 'Document Types'
        this.$router.push({ name: 'ConfigureDocumentTypes' })
      }
    },
    handleTenantTextractChange(event) {
      // Listen for changes to tenant textract status (for all users)
      const previousStatus = this.selectedTenantUsesTextract
      this.updateTenantTextractStatus()

      console.log('Configure: Tenant textract status changed from', previousStatus, 'to', this.selectedTenantUsesTextract)

      // Force immediate redirect if tenant now uses Textract and we're not on Document Types
      if (this.selectedTenantUsesTextract && this.currentRouteName !== 'ConfigureDocumentTypes') {
        console.log('Configure: Redirecting to Document Types due to Textract tenant selection')
        this.selectedItem = 'Document Types'
        this.$router.push({ name: 'ConfigureDocumentTypes' })
      }
    },

    // Minimal fix: Wait for TenantDetails to be populated by Sidebar (Tenant Admin only)
    waitForTenantDetails() {
      const checkInterval = 100 // Check every 100ms
      const maxWait = 3000 // Max 3 seconds
      let waited = 0

      const check = () => {
        const tenantDetails = localStorage.getItem('TenantDetails')
        if (tenantDetails) {
          this.initializeTenantAdmin()
          return
        }

        waited += checkInterval
        if (waited >= maxWait) {
          this.initializeTenantAdmin()
          return
        }

        setTimeout(check, checkInterval)
      }

      check()
    },

    // Initialize Tenant Admin after TenantDetails is available
    initializeTenantAdmin() {
      // Clear loading state - navigation will now show
      this.isLoadingTenantConfig = false

      // Try to get AI method from TenantDetails if available
      const tenantDetails = localStorage.getItem('TenantDetails')
      if (tenantDetails) {
        try {
          const details = JSON.parse(tenantDetails)
          const aiMethodConfig = details.find((config) => config.key === 'ai_method')
          if (aiMethodConfig) {
            const usesBedrock = aiMethodConfig.value === 'Bedrock Data Automation'
            const usesTextract = aiMethodConfig.value === 'Textract'
            console.log('Configure: Found AI method in TenantDetails:', aiMethodConfig.value, '-> bedrock:', usesBedrock, '-> textract:', usesTextract)

            if (this.selectedTenantUsesBedrock !== usesBedrock || this.selectedTenantUsesTextract !== usesTextract) {
              this.selectedTenantUsesBedrock = usesBedrock
              this.selectedTenantUsesTextract = usesTextract
              this.$forceUpdate()
            }
            return
          }
        } catch (error) {
          console.error('Configure: Error parsing TenantDetails:', error)
        }
      }

      // Fallback to store initialization
      tenantSelectionStore
        .initializeRegularUserAiMethod()
        .then(() => {
          const newState = tenantSelectionStore.getCurrentState()
          if (this.selectedTenantUsesBedrock !== newState.selectedTenantUsesBedrock || this.selectedTenantUsesTextract !== newState.selectedTenantUsesTextract) {
            this.selectedTenantUsesBedrock = newState.selectedTenantUsesBedrock
            this.selectedTenantUsesTextract = newState.selectedTenantUsesTextract
            this.$forceUpdate()
          }
        })
        .catch((error) => {
          console.error('Configure: Failed to initialize AI method:', error)
        })
    },
  },
}
</script>

<style scoped>
@import '@/styles/jobHistory.css';

.arrowDownIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.arrowDownIcon.rotated,
.rotated {
  transform: rotate(-180deg);
}

.configureItemIcon {
  width: 28px;
  height: 28px;
}

.actualPage {
  width: 100%;
  height: 100%;
}

.headerBar {
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-direction: row;
}

.jobHistorySidebarStack {
  display: flex;
  flex-direction: column;
}

.jobItem {
  cursor: pointer;
}

.jobItemSidebarOpen {
  cursor: pointer;
  background-color: #e9f1f6;
}

.jobItemSidebarOpen:hover {
  background-color: #f0f0f0;
}

.activeItem {
  background-color: #d1e6f1;
}

.onCollapse {
  gap: 16px;
}

.no-write-permission {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);
}
</style>
